/**
 * Daily recurrence configuration component
 */
export function DailyRecurrenceConfig({ recurrence, onChange }) {
  return (
    <div className="recurrence-config">
      <div className="form-row form-row-2">
        <div className="form-group">
          <label>Startdatum *</label>
          <input
            type="date"
            value={recurrence.startDate}
            onChange={(e) => onChange({ ...recurrence, startDate: e.target.value })}
            required
          />
        </div>

        <div className="form-group">
          <label>Enddatum (optional)</label>
          <input
            type="date"
            value={recurrence.endDate || ''}
            onChange={(e) => onChange({ ...recurrence, endDate: e.target.value || null })}
            min={recurrence.startDate}
          />
        </div>
      </div>
    </div>
  );
}
